// extracted by mini-css-extract-plugin
export var banner = "_g4-0";
export var closeButton = "_g4-2";
export var greenCheckmark = "_g4-3";
export var hereLink = "_g4-4";
export var titleIcon = "_g4-1";